import { Typography } from '@mui/material';

export function FSModalTitle({ title }: { title: string }) {
  return (
    <Typography sx={{ fontSize: '1.5rem', fontWeight: '700' }}>
      {title}
    </Typography>
  );
}
